// extracted by mini-css-extract-plugin
export default {"formItem":"formItem_formItem__1XzSD","formItem_action":"formItem_formItem_action__Xy5jL"};